// import { Link as RouterLink } from "react-router-dom";
import {HashLink} from "react-router-hash-link";
import useTheme from "@mui/material/styles/useTheme";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

const TextLink = ({text, to}) => {
    const theme = useTheme();
    const isExternal = /^https?:\/\//.test(to);

    const textLinkStyle = {
        display: "inline-block",
        color: theme.palette.primary.main,
        textDecoration: "underline",
        textDecorationColor: theme.palette.primary.dark,
    };

    const textLinkHoverStyle = {
        "&:hover": {
            textDecoration: "underline",
            textDecorationColor: theme.palette.secondary.dark,
        },
    };

    if (isExternal) {
        return (
            <a
                href={to}
                target="_blank"
                rel="noopener noreferrer"
                style={textLinkStyle}
            >
                <Typography component="span" sx={textLinkHoverStyle}>
                    {text}
                </Typography>
            </a>
        );
    }

    return (
        <Link component={HashLink} to={to} smooth style={textLinkStyle}>
            <Typography component="span" sx={textLinkHoverStyle}>
                {text}
            </Typography>
        </Link>
    );
};

export default TextLink;
